import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from '../Atoms/Typography.js';
import { useTranslation } from 'react-i18next';
import { Swiper } from './../external_lib/swiper/react/swiper.js';
import { SwiperSlide } from './../external_lib/swiper/react/swiper-slide.js';
import './../external_lib/swiper/core/core.js';
import './../external_lib/swiper/shared/dom.js';
import Autoplay from './../external_lib/swiper/modules/autoplay/autoplay.js';
import TestimonialOneCard from '../Components/Organisms/TestimonialsOne/Web/testimonial-one-card.component.js';
import CarouselProgressIndicator from '../Molecules/CarouselProgressIndicator.js';
import LeftOutlined from './../external_lib/@ant-design/icons/LeftOutlined.js';
import RightOutlined from './../external_lib/@ant-design/icons/RightOutlined.js';

function TestimonialsOne(_a) {
    var testimonials = _a.testimonials, classes = _a.classes;
    var _b = React__default.useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = React__default.useState(null), swiper = _c[0], setSwiper = _c[1];
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: classNames('testimonials-one', classes) },
        React__default.createElement("div", { className: "testimonials-one__content" },
            React__default.createElement(Typography, { classes: "testimonials-one__title", variant: 'displayText' }, t('landingScreen.testimonialTitle')),
            React__default.createElement(Swiper, { spaceBetween: 32, centeredSlides: true, onActiveIndexChange: function (s) { return setActiveIndex(s.activeIndex); }, initialSlide: testimonials.length <= 2 ? 0 : 1, modules: [Autoplay], autoplay: {
                    delay: 3000
                }, onSwiper: function (s) {
                    setSwiper(s);
                }, breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: testimonials.length < 2 ? 1 : 2
                    }
                } }, testimonials.map(function (testimonial, index) { return (React__default.createElement(SwiperSlide, { key: testimonial.name + index },
                React__default.createElement(TestimonialOneCard, { key: testimonial.name + index, name: testimonial.name, quote: testimonial.quote, image: testimonial.image, designation: testimonial.designation }))); })),
            testimonials.length > 1 ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(CarouselProgressIndicator, { slides: testimonials, position: activeIndex }),
                React__default.createElement(LeftOutlined, { onClick: function () { return swiper.slidePrev(); }, className: "testimonials-left__navigator" }),
                React__default.createElement(RightOutlined, { onClick: function () { return swiper.slideNext(); }, className: "testimonials-right__navigator" }))) : null)));
}

export { TestimonialsOne as default };
//# sourceMappingURL=TestimonialsOne.js.map
